<template>
  <b-container fluid>
    <!-- <img :src="require('../assets/img/tbm_loader.gif')"> -->
    <!-- <div>
        <div v-for="data in salesJson">{{data}}</div>
    </div> -->
    <b-row class="mb-3">
      <b-col cols="12" v-if="roleID==1">
        <router-link :to="{name: 'SalesForm'}">
            <b-button variant="primary">
              <i class="fa fa-plus-circle"></i>&nbsp; Create New Sales
            </b-button>
        </router-link>
        </b-col>
    </b-row>

    <b-card>
    <div slot="header">
      <strong>Sales List</strong> <!-- <small>Table</small> -->
    </div>
    <!-- User Interface controls -->


      <b-row>
      <!-- <b-col cols="12" md="12" xl="5" class="my-2">
        <b-form-group label-cols-xl="5" label-align-xl="right" label="Search" class="mb-3"> -->
      <b-col cols="12" class="my-2">
        <b-form-group label="" class="mb-3">
          <b-input-group class="">
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- <b-col cols="12" md="12" xl="5" class="my-2">
        <b-form-group label="Sort" label-cols-xl="5" label-align-xl="right" class="mb-3">
          <b-input-group class="">
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
              <option :value="false">Asc</option> <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col> -->

      <!-- <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort direction" class="mb-0">
          <b-form-select v-model="sortDirection">
            <option value="asc">Asc</option>
            <option value="desc">Desc</option>
            <option value="last">Last</option>
          </b-form-select>
        </b-form-group>
      </b-col> -->


    </b-row>

    <!-- Main table element -->
    <b-table
      v-model="filterOn"
      responsive
      hover
      show-empty
      :items="getAllSalesPagination"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      selectable
      :select-mode="'single'"
      :busy="isLoading"
      selectedVariant="warning"
      @row-clicked="showMenus"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <div><img src="../assets/img/tbm_loader.gif" width="100" height="100"></div>
        <div style="margin-top: -20px"><small>Loading...</small></div>
      </div>

      <template slot="fullname" slot-scope="row">
        {{ (row.item || {}).first_name }} {{ (row.item || {}).last_name }}
        <!-- {{ row.item.first_name }} {{ row.item.last_name || {} }} -->
        <!-- {{ fullname((row.item || {}).first_name +' '+ (row.item || {}).last_name) }} -->
      </template>

      <template slot="status" slot-scope="row">
          <b-badge href="#" pill variant="success" v-if="row.item.status==1">Active</b-badge>
          <b-badge href="#" pill variant="secondary" v-if="row.item.status==2">Inactive</b-badge>
      </template>

      <!-- <template slot="actions" slot-scope="row"> -->
        <!-- <b-button id="dropdown-grouped" size="sm" @click="showDet(row,1)">{{ row.detailsShowing ? 'Hide' : 'Show' }}</b-button> -->
        <!-- <b-button id="dropdown-grouped" @click="showDet(row,2)">More</b-button> -->

        <!-- <b-button size="sm" @click="activeConfirm(row.item)" class="mb-2 mr-2" v-if="roleID==1" :variant="row.item.status == 2 ? 'success':'warning'">
          {{ row.item.status == 2 ? '&nbsp;Active&nbsp;' : 'Inactive' }}
        </b-button>

        <b-button size="sm" @click="resignConfirm(row.item)" class="mb-2 mr-2" v-if="roleID==1" variant="danger">Resign
        </b-button> -->

        <!-- <router-link :to="{name: 'Structure', params: {sales_id: row.item.id}}">
        <b-button size="sm" class="mr-2">Show Structure
        </b-button>
        </router-link> -->

        <!-- <b-button size="sm" @click="row.toggleDetails" class="mb-2 mr-2">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Structure
        </b-button> -->



        <!-- <router-link :to="{name: 'SalesFormEdit', params: {sales_id: row.item.id}}"> -->

        <!-- <b-button size="sm" class="mb-2 mr-2" v-if="row.item.role_id=='Agro' || row.item.role_id=='Area Manager'" @click="showModalAdd(row.item)" variant="primary">{{ row.type ? 'Agro' : 'FA' }} -->
         <!-- Add {{ row.item.role_id == 'Agro' ? 'FA' : 'Agro' }} -->
        <!-- </b-button> -->

        <!-- </router-link> -->

        <!-- <b-button size="sm" @click="resetPassword(row.item)" class="mb-2 mr-2" v-if="roleID==1" variant="dark">
          Reset Password
        </b-button> -->

        <!-- <b-dropdown id="dropdown-grouped" size="sm" text="Action">
          <b-dropdown-item-button @click="showDet(row,1)">{{ row.detailsShowing ? 'Hide' : 'Show' }} Structure</b-dropdown-item-button>
          <b-dropdown-item-button @click="showDet(row,2)">More</b-dropdown-item-button>
          <b-dropdown-item-button v-if="row.item.role_id==3 || row.item.role_id==2" @click="showModalAdd(row.item)">Add {{ row.item.role_id == 3 ? 'FA' : 'Agro' }}</b-dropdown-item-button>
          <b-dropdown-divider v-if="roleID==1"></b-dropdown-divider>
          <b-dropdown-item-button @click="activeConfirm(row.item)" v-if="roleID==1">{{ row.item.status == 2 ? 'Active' : 'Inactive' }}</b-dropdown-item-button>
          <b-dropdown-item-button @click="resetPassword(row.item)" v-if="roleID==1">Reset Password</b-dropdown-item-button>
        </b-dropdown> -->

        <!-- //lastedited -->
        <!-- <div>
          <b-dropdown id="dropdown-grouped" size="sm" text="Action">
            <span v-if="!buttonStructure"><b-dropdown-item-button @click="showDet(row,1)">Show Structure</b-dropdown-item-button></span>
            <b-dropdown-item-button @click="showDet(row,2)">More</b-dropdown-item-button>
            <b-dropdown-item-button v-if="row.item.role_id==3 || row.item.role_id==2" @click="showModalAdd(row.item)">Add {{ row.item.role_id == 3 ? 'FA' : 'Agro' }}</b-dropdown-item-button>
            <b-dropdown-divider v-if="roleID==1"></b-dropdown-divider>
            <b-dropdown-item-button @click="activeConfirm(row.item)" v-if="roleID==1">{{ row.item.status == 2 ? 'Active' : 'Inactive' }}</b-dropdown-item-button>

            <b-dropdown-item-button @click="resetPassword(row.item)" v-if="roleID==1">Reset Password</b-dropdown-item-button>
          </b-dropdown>
        </div> -->


        <!-- <b-dropdown-item-button>Active</b-dropdown-item-button>
        <b-dropdown-item-button>First item</b-dropdown-item-button>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item-button>First item</b-dropdown-item-button>
      <b-dropdown-item-button>Second Item</b-dropdown-item-button> -->

      <!-- </template> -->

      <template slot="row-details" slot-scope="row">
        <div>
          <b-row align-h="end">
        <!-- <span ><b-dropdown-item-button @click="showDet(row,1)">Show Structure</b-dropdown-item-button></span> -->
        <!-- <span right> -->
          <!-- <b-button class="mr-2" @click="row.toggleDetails">{{ row.detailsShowing ? 'Hide' : 'Show' }} Structure</b-button> -->
          <b-button-group  class="mx-1 m-3">
            <b-button @click="editConfirm(row.item)" variant="outline-warning" v-if="roleID==1">Edit</b-button>
            <b-button @click="activeConfirm(row.item)" :variant="row.item.status == 2 ? 'outline-success' : 'outline-warning'" v-if="roleID==1">{{ row.item.status == 2 ? 'Set Active' : 'Set Inactive' }}</b-button>
            <!-- <b-button @click="resignConfirm(row.item)" variant="outline-danger" v-if="roleID==1">Resign</b-button> -->
            <b-button @click="resetPassword(row.item)" variant="outline-danger" v-if="roleID==1">Reset Password</b-button>
          </b-button-group>
          </b-row>
          </div>
        <!-- </span> -->
        <b-card no-body>
          <b-card-header>
          <!-- <b-row align-h="end" class="m"> -->

            <b-row align-v="center">
              <b-col class="text-left">Structure of {{ row.item.fullname }}</b-col>
                <b-col class="text-right"><b-button @click="showModalAdd(row.item)" variant="primary" v-if="row.item.role_id==3 || row.item.role_id==2">Add {{ row.item.role_id == 3 ? 'Field Assistant' : 'Agro' }}</b-button></b-col>
            </b-row>

            </b-card-header>
          <!-- </b-row> -->
          <b-card-body>
          <ul id="sales-tree" data-widget="tree">
              <li class="treeview" v-for="(value, key) in row.item.structure" :key="key" >
                  <a href="#"><i :class="(!value.child || value.child.length==0) ? '' : 'fa fa-folder'" ></i> {{!value.child || value.child.length==0 ? 'No Structure Available' : value.name }}</a>
                  <ul class="treeview-menu">
                      <li class="treeview" v-for="(am, gmKey) in value.child" :key="gmKey">
                          <a href="#"><i class="fa fa-folder" v-if="am.name"></i>{{ am.name }}</a>
                          <!-- <div class="btn-group">
                              <button class="btn btn-xs btn-link" @click="remove(value, gmKey)"><i class="fa fa-times"></i> remove</button>
                          </div> -->
                          <ul class="treeview-menu">
                              <li class="treeview" v-for="(fa, faKey) in am.child" :key="faKey">
                                  <a href="#"><i class="fa fa-folder" v-if="fa.name"></i> {{ fa.name }}</a>
                                  <!-- <div class="btn-group">
                                      <button class="btn btn-xs btn-link" @click="remove(value, faKey)"><i class="fa fa-times"></i> remove</button>
                                  </div> -->
                              </li>
                          </ul>
                      </li>
                  </ul>
              </li>
          </ul>
          </b-card-body>
          <!-- <ul>
            <li v-for="(value, key) in row.item.structure" :key="key">{{ key }}: {{ value }}</li>
          </ul> -->
        </b-card>
      </template>
    </b-table>

<!-- ### ALTERNATIVE VERSION ###
    <br>
    <div v-if="hasSelected" class="swal2-container swal2-center swal2-fade swal2-shown" style="overflow-y: auto;">
        <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
            <div class="swal2-header">
                <ul class="swal2-progress-steps" style="display: none;"></ul>
                <div class="swal2-icon swal2-error" style="display: none;"><span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>
                </div>
                <div class="swal2-icon swal2-question" style="display: none;"></div>
                <div class="swal2-icon swal2-warning swal2-animate-warning-icon" style="display: flex;"></div>
                <div class="swal2-icon swal2-info" style="display: none;"></div>
                <div class="swal2-icon swal2-success" style="display: none;">
                    <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div><span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
                    <div class="swal2-success-ring"></div>
                    <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                    <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
                </div><img class="swal2-image" style="display: none;">
                <h2 class="swal2-title" id="swal2-title" style="display: flex;">Are you sure to edit data Sasa AM?</h2>
                <button type="button" class="swal2-close" aria-label="Close this dialog" style="display: none;">×</button>
            </div>
            <div class="swal2-content">
                <div id="swal2-content" style="display: none;"></div>
                <input class="swal2-input" style="display: none;">
                <input type="file" class="swal2-file" style="display: none;">
                <div class="swal2-range" style="display: none;">
                    <input type="range">
                    <output></output>
                </div>
                <select class="swal2-select" style="display: none;"></select>
                <div class="swal2-radio" style="display: none;"></div>
                <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
                    <input type="checkbox"><span class="swal2-label"></span></label>
                <textarea class="swal2-textarea" style="display: none;"></textarea>
                <div class="swal2-validation-message" id="swal2-validation-message"></div>
            </div>
            <div class="swal2-actions">
                <button @click="editSelected" type="button" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block; background-color: rgb(255, 193, 7); border-left-color: rgb(255, 193, 7); border-right-color: rgb(255, 193, 7);">Edit Data</button>
                <button @click="hasSelected=false" type="button" class="swal2-cancel swal2-styled" aria-label="" style="display: inline-block;">Cancel</button>
                <button @click="hasSelected=false" type="button" class="swal2-cancel swal2-styled" aria-label="" style="display: inline-block;">More</button>
                <div id="dropdown-grouped" class="dropdown btn-group b-dropdown">

                    <button @click="menuChange" id="dropdown-grouped__BV_toggle_" aria-haspopup="true" aria-expanded="true" type="button" class="btn dropdown-toggle btn-secondary btn-sm swal2-cancel swal2-styled">More</button>
                    <ul :class="menuOpen==true ? 'dropdown-menu show' : 'dropdown-menu'" role="menu" tabindex="-1" aria-labelledby="dropdown-grouped__BV_toggle_" x-placement="top-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-52px, -161px, 0px);">
                        <li>
                            <button role="menuitem" type="button" class="dropdown-item" @click="selectedItem.toggleDetails">{{ selectedItem.detailsShowing ? 'Hide' : 'Show' }} Structure</button>
                        </li>
                        <li>
                            <button role="menuitem" type="button" class="dropdown-item"v-if="selectedItem.role_id==3 || selectedItem.role_id==2" @click="showModalAdd(selectedItem)">Add {{ selectedItem.role_id == 3 ? 'FA' : 'Agro' }}</button>
                        </li>
                        <li>
                            <hr role="separator" aria-orientation="horizontal" class="dropdown-divider">
                        </li>
                        <li>
                            <button role="menuitem" type="button" class="dropdown-item">Inactive</button>
                        </li>
                        <li>
                            <button role="menuitem" type="button" class="dropdown-item">Reset Password</button>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="swal2-footer" style="display: none;"></div>
        </div>
    </div> -->


<!-- ## ADD MEMBER SECTION ## -->
    <b-modal title="Add Member" size="lg" id="modal-scoped" class="modal-warning" v-model="addMemberModal" @ok="addMemberModal = false" ok-variant="success">
     <!-- <b-form-input type="text" id="sales_id" value="Tomang"></b-form-input> -->
     <template v-slot:modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <!-- <b-button size="sm" variant="outline-danger" @click="close()">
        Close Modal
      </b-button> -->
        <h5>Add Member</h5>
    </template>
     <b-row>
       <b-col cols="12" md="12" xl="6" class="my-2">
         <b-form-group label="Search" label-cols-xl="2" label-align-xl="right" class="mb-3">
           <b-input-group>
             <b-form-input v-model="filterMember" placeholder="Type to Search"></b-form-input>
             <b-input-group-append>
               <b-button :disabled="!filterMember" @click="filterMember = ''">Clear</b-button>
             </b-input-group-append>
           </b-input-group>
         </b-form-group>
       </b-col>

       <b-col cols="12" md="12" xl="6" class="my-2">
         <b-form-group label="Sort" label-cols-xl="2" label-align-xl="right" class="mb-3">
           <b-input-group>
             <b-form-select v-model="sortByMember" :options="sortOptionsMember">
               <option slot="first" :value="null">-- none --</option>
             </b-form-select>
             <b-form-select v-model="sortDescMember" :disabled="!sortByMember" slot="append">
               <option :value="false">Asc</option> <option :value="true">Desc</option>
             </b-form-select>
           </b-input-group>
         </b-form-group>
       </b-col>

       <!-- <b-col md="6" class="my-1">
         <b-form-group label-cols-sm="3" label="Sort direction" class="mb-0">
           <b-form-select v-model="sortDirection">
             <option value="asc">Asc</option>
             <option value="desc">Desc</option>
             <option value="last">Last</option>
           </b-form-select>
         </b-form-group>
       </b-col> -->


     </b-row>
      <b-table
      responsive
      hover
      show-empty
      :items="salesListMember"
      :fields="fieldsModal"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filterMember"
      :sort-by.sync="sortByMember"
      :sort-desc.sync="sortDescMember"
      :sort-direction="sortDirectionMember"
      @filtered="onFilteredMember"
      selectable
      :select-mode="'single'"
      selectedVariant="warning"
    >
    <template slot="first_name" slot-scope="row">
      {{ (row.item || {}).first_name }} {{ (row.item || {}).last_name }}
    </template>

      <template slot="actions" slot-scope="row">

        <b-button size="sm" @click="addMember(row.item)" class="mr-2">
          {{ 'Add' }}
        </b-button>
        <!-- <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button> -->
      </template>

      <template slot="row-details" slot-scope="row">
        <b-card>
          <!-- <ul id="sales-tree" data-widget="tree">
              <li class="treeview">
                  <a href="#"><i class="fa fa-folder"></i> {{ project.name }}</a>
                  <ul class="treeview-menu">
                      <li class="treeview" v-for="(am, gmKey) in project.child" :key="gmKey">
                          <a href="#"><i class="fa fa-folder"></i>{{ am.name }}</a>
                          <ul class="treeview-menu">
                              <li class="treeview" v-for="(fa, faKey) in am.child" key="faKey">
                                  <a href="#"><i class="fa fa-folder"></i> {{ fa.name }}</a>
                              </li>
                          </ul>
                      </li>
                  </ul>
              </li>
          </ul> -->
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>

    
    </b-modal>

    <!-- <b-modal id="modal-center" title="Loading" size="sm" class="modal-success" v-model="loadingModal" @ok="loadingModal = false">
      <template slot="modal-footer" slot-scope="{}">
        <br>
      </template>
    </b-modal> -->

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>

    <b-container>
    <b-row align-h="center">
      <b-col col cols="8" sm="4" md="2" lg="2" class="mb-2">
        <!-- <b-form-select v-model="perPage" :options="pageOptions"></b-form-select> -->
        From {{rowFrom || '...'}} to {{rowTo || '...'}}
      </b-col>
      <b-col col cols="12" sm="8" md="8" lg="8">
          <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="rowTotal"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col col cols="8" sm="4" md="2" lg="2" class="mb-2">
        <!-- <b-form-select v-model="perPage" :options="pageOptions"></b-form-select> -->
        Total {{rowTotal || '...' }} rows
      </b-col>
    </b-row>
    </b-container>
    </b-card>
  </b-container>
</template>
<script>
import { isLoggedIn, getIdToken, removeToken, getDataToken, getHeaderToken, getRoleId } from '../user/token.js'
import axios from 'axios'
import { apiRouter } from '../router/api-routing.js'
// import Vue from 'vue'
// import QrcodeVue from 'qrcode.vue'
// import salesJson from '../json/sales.json'

// Vue.mixin({
//   data: function() {
//     return {
//       get globalReadOnlyProperty() {
//         return "Can't change me!";
//       }
//     }
//   }
// })

// Vue.component('child', {
//   template: "<div>In Child: {{globalReadOnlyProperty}}</div>"
// });

// new Vue({
//   el: '#app',
//   created: function() {
//     this.globalReadOnlyProperty = "This won't change it";
//   }
// });

export default {
    name: 'Sales',
    components: {
      // QrcodeVue
    },
    data() {
      return {
        // hasSelected: false,
        // menuOpen: false,
        // selectedItem: {
        //   item: {}
        // },
        roleID: '',
        access_token: '',
        token_type: 'Bearer',
        authorization: '',
        // salesJson: salesJson,
        parentId: null,
        salesList: [],
        salesListMember: null,
        fields: [
          { key: 'sales_id', label: 'Sales ID', sortable: false },
          { key: 'fullname', label: 'Sales Name', sortable: false },
          { key: 'email', label: 'Email', sortable: false },
          { key: 'phone', label: 'Phone', sortable: false },
          { key: 'role_name', label: 'Position', sortable: false },
          { key: 'status', label: 'Status', sortable: false },
          // { key: 'actions', label: 'Action' },
        ],
        fieldsModal: [
          { key: 'sales_id', label: 'Sales ID', sortable: true, sortDirection: 'asc' },
          { key: 'first_name', label: 'Sales Name', sortable: true, class: 'text-left' },
          { key: 'role_name', label: 'Position' },
          { key: 'actions', label: 'Action' },
        ],
        totalRows: 1,
        totalRowsMember: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortByMember: null,
        sortDesc: false,
        sortDescMember: false,
        sortDirection: 'asc',
        sortDirectionMember: 'asc',
        filter: '',
        filterMember: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        editModal: false,
        deleteModal: false,
        addMemberModal: false,
        showStructure: false,
        isOpen: false,
        project: {},
        isLoading: false,
        rowFrom: '',
        rowTo: '',
        rowTotal: '',
        keywordSearch: '',

        //Temporary var
        structure: []
      }
    },
    computed: {
      getStructure(id) {
        let structure = []
        this.structure.forEach( structure => {
          if(structure.id == id) {
            structure = structure.structure
          }
        })
        return structure
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },

      sortOptionsMember() {
        // Create an options list from our fields
        return this.fieldsModal
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },

      isFolder: function () {
        return this.item.children &&
          this.item.children.length
      }
    },
    watch: {
    },
    created() {
      let $vm = this
      this.roleID = getRoleId()

      //this.checkCookies()
      this.checkSession()
    },
    mounted(){

    },
    methods: {
      showDet(row, opt){
        // console.log('showDet', row)
        // if (opt==1){
        //   this.buttonStructure = true
        //   this.buttonMore = false
        // } else {
        //   this.buttonStructure = false
        //   this.buttonMore = true
        // }
        // row.toggleDetails()
      },
      menuChange(){
        // this.menuOpen = !this.menuOpen
      },
      editSelected(){
        const item = this.selectedItem
         this.$router.replace({name: 'SalesFormEdit', params: {sales_id: item.sales_id, id: item.id}});
      },
      checkCookies(){
        // console.log('cookies',this.$cookies.get("TBM"))
        // console.log('cookies exist',this.$cookies.isKey("TBM"))
        // var secs=5;
        // var exp = new Date(new Date().getTime() + secs*1000);
        // document.cookie = 'ExpirationCookieTest=1; expires='+exp.toUTCString();
        // if (document.cookie && document.cookie.indexOf('ExpirationCookieTest=1') != -1) {
        //      status = 'Cookie successfully set. Expiration in '+secs+' seconds';
        //  } else {
        //      status = 'Cookie NOT set. Please make sure your browser is accepting cookies';
        //  }
        //  console.log(status)
      },
      checkSession(){
        if(isLoggedIn() === 1){
          // this.getAllSales()
        } else {
          this.$router.push({name: 'Login'});
        }
      },
      getAllSales(){
        this.isLoading = true
        let $vm = this;
        axios.get(apiRouter().view_all_sales, getHeaderToken())
        .then(function (response){
            $vm.isLoading = false;
             //console.log('vsa',response);
            //document.getElementById('testLoading').click();
            if(response.status === 200){
                // console.log("suksessss");
                // console.log('gas',response.data);
                // let push = [];
                // let search = [];

                response.data.forEach( item => {
                  item.fullname = item.first_name + ' ' + item.last_name;
                  let tempItem = {
                    sales_id: item.sales_id,
                    fullname: item.fullname,
                    email: item.email,
                    phone: item.phone,
                    role_name: item.role_name,
                    status: item.status
                  }
                  // this.structure.push({id: item.id, structure: item.structure})
                    $vm.salesList.push(item)
                })
                $vm.totalRows = response.data.length

                // console.log(response.data)

                // for(var i = 0; i < response.data.length; i++){
                //   // let temp_role;
                //
                //   // if (response.data[i].role_id == '2'){
                //   //   response.data[i].role_id = 'Area Manager';
                //   //
                //   // } else if (response.data[i].role_id == '3'){
                //   //   response.data[i].role_id = 'Agro';
                //   //
                //   // } else if (response.data[i].role_id == '4'){
                //   //   response.data[i].role_id = 'FA';
                //   //
                //   // }
                //   //console.log("abc " + response.data[i].role_id);
                //   push.push(response.data[i]);
                //   // console.log(push);
                // }

                //$vm.salesList = push;

                // $vm.$nextTick(()=>{
                //   $vm.salesList = push
                //   $vm.totalRows = push.length
                // })

                this.filterOn = [sales_id, fullname, email, phone, role_name, status]


                //this.salesList = push;
            } else {
              // console.log("suksessss not 200");
            }
          })
          .catch(function (error) {
              $vm.isLoading = false;
              // console.log(error);
              //document.getElementById('testLoading').click();
          });
        // }
        // Set the initial number of items
        // this.totalRows = this.items.length
      },
      getAllSalesPagination(ctx){
        // console.log('ctx', ctx)
        // console.log('current page', ctx.currentPage)

        const promise = axios.get(apiRouter().view_all_sales + '?search=' + ctx.filter + '&page=' + ctx.currentPage, getHeaderToken())

        // Must return a promise that resolves to an array of items
        return promise.then(data => {
          // Pluck the array of items off our axios response
          // console.log('data', data.data)
          
          // this.customerList = data.data.data
          // let $rd = this
          this.rowFrom = data.data.from
          this.rowTo = data.data.to
          // console.log('rowTo', rowTo)
          this.rowTotal = data.data.total
          // this.totalRows = data.data.total

          const items = data.data.data
          this.customerList = data.data.data
          this.currentPage = ctx.currentPage
          // Must return an array of items or an empty array if an error occurred
          return items || []
        })
      },
      showMenus(row){
        row._showDetails = !row._showDetails
      },
      editConfirm(item) {
         //console.log('item', item)
         if (this.roleID==1){
          var name = item.first_name +" "+ item.last_name
          var message = 'Are you sure to edit data ' + name +'?'

          // this.hasSelected = true
          // this.selectedItem = item

          // console.log(item)

          this.$swal({title: message, html:'',text: '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Edit Data',
            confirmButtonColor: '#FFC107',
            showCloseButton: false,
            showLoaderOnConfirm: true,
          })
          .then((result) => {
              if (result.value) {
                // (console.log('item', item))
                this.$router.replace({name: 'SalesFormEdit', params: {sales_id: item.sales_id, id: item.id}});
              }
            })
         }
      },
      resignConfirm(item) {
        var name = item.first_name +" "+ item.last_name
        this.updateStatus('3', name, item.sales_id)

      },
      activeConfirm(item) {
        var name = item.first_name +" "+ item.last_name

        if (item.status == 1){ //Active
          this.updateStatus('2', name, item.sales_id)

        } else if (item.status == 2){ //Inactive
          this.updateStatus('1', name, item.sales_id)

        } else {
          this.updateStatus('2', name, item.sales_id)
        }
      },
      updateStatus(status, name, sales_id){
        var action;
        var buttonVariant;

        if (status == 1){
          action = 'Active'
          buttonVariant = '#4DBD74' //'#008841'
          // buttonVariant = 'success'

        } else if (status == 2){
          action = 'Inactive'
          buttonVariant = '#FFC107'
          // buttonVariant = 'warning'

        } else if (status == 3){
          action = 'Resign'
          buttonVariant = '#DC3545'
        }

        let message = 'Are you sure to Set ' + action + ' for ' + name +'?'

        // this.$bvModal.msgBoxConfirm('Are you sure to set ' + action + ' for ' + name +'?', {
        //     title: action + ' Confirmation',
        //     size: 'sm',
        //     buttonSize: 'sm',
        //     okVariant: buttonVariant,
        //     okTitle: 'Set ' + action,
        //     cancelTitle: 'Cancel',
        //     headerClass: 'p-2 border-bottom-0',
        //     footerClass: 'p-2 border-top-0',
        //     centered: true
        //   })

        this.$swal({title: message, html:'',text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Set ' + action,
          confirmButtonColor: buttonVariant,
          showCloseButton: false,
          showLoaderOnConfirm: true,
        })
        .then((result) => {
            if(result.value) {

              axios.post(apiRouter().update_sales_status + sales_id, {'status': status}, getHeaderToken())
              .then(response => {
                  // console.log("response", response.data.code)
                  if(response.data.code == '200'){
                    //console.log('boled');
                    this.modalOK('', '', 'Set ' + action + ' for ' + name + ' successfully', 'success');
                  } else {

                  }
              }) .catch(function (error) {
                  // console.log(error);
              });
            }
          }) .catch(err => {
            // An error occurred
          })
      },
      modalOKv2(item, id, message, buttonVariant){
        //console.log('message, ', message);
        this.$bvModal.msgBoxOk(message, {
          title: 'Information',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: buttonVariant,
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        }).then(value => {
          if(item == ''){
            this.reloadPage();
          }
          if(id != ''){
            const index = this.salesListMember.findIndex(post => post.id === id) // find the post index
            if (~index) // if the post exists in array
            this.salesListMember.splice(index, 1) //delete the post
          }
        })
        .catch(err => {
          // An error occurred
        })
      },
      modalError(errorMessage){
        this.modalOK('no','',errorMessage, 'error');
      },
      modalOK(item, id, message, buttonVariant){
       this.$swal({title: message, html:'',text: '',
          type: buttonVariant,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#4DBD74',
          showCloseButton: false,
          showLoaderOnConfirm: true,
      }).then((result) => {
        if(item == ''){
            this.reloadPage();
        }
        if(id != ''){
          const index = this.salesListMember.findIndex(post => post.id === id) // find the post index
          if (~index) // if the post exists in array
          this.salesListMember.splice(index, 1) //delete the post
        }
      });
    },

    addMember(item){
        let $vm = this;
        this.$bvModal.msgBoxConfirm('Add parent to ' + item.first_name + ' ' + item.last_name +' ?', {
            title: ' Confirmation',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'Add',
            cancelTitle: 'Cancel',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })
          .then(value => {
            // console.log(value)
            if (value){
              axios.post(apiRouter().add_member + item.id, {'parent_id': $vm.parentId}, getHeaderToken())
              .then(response => {
                  // console.log("response", response)
                  if(response.data.code == '200'){
                    this.modalOK(item, item.id, 'Set parent successfully', 'success');
                  } else {
                  }
              }) .catch(function (error) {
                  // console.log(error);
              });
            }
          }) .catch(err => {
            // An error occurred
          })
      },
      showModalAdd(item){
        let $vm = this;
        if (item.parent_id == 0 && item.role_id == 3) { //Agro and Agro have AM
          // block add Member
          this.modalError('This Agro have not Area Manager', 'error', '');

        } else {
          axios.get(apiRouter().view_list_sales_by_id + item.id, getHeaderToken())
          .then(function (response){
              // console.log(response);
              //document.getElementById('testLoading').click();
              if(response.status === 200){
                  // console.log("suksessss");
                  let push = [];
                  for(var i = 0; i < response.data.length; i++){
                    // let temp_role;


                    // if (response.data[i].role_id == '2'){
                    //   response.data[i].role_id = 'Area Manager';
                    //
                    // } else if (response.data[i].role_id == '3'){
                    //   response.data[i].role_id = 'Agro';
                    //
                    // } else if (response.data[i].role_id == '4'){
                    //   response.data[i].role_id = 'FA';
                    //
                    // }
                    //console.log("abc " + response.data[i].role_id);
                    push.push(response.data[i]);
                    // console.log('aaa', push);

                  }
                  //$vm.salesList = push;
                  $vm.$nextTick(() => {
                    // this.salesListMember = push;
                    // this.totalRows = push.length;
                    $vm.parentId = item.id;
                    $vm.salesListMember = push;
                    $vm.totalRowsMember = push.length;
                    $vm.addMemberModal = true;
                     // console.log('aaa', $vm.salesListMember);
                  });
                  //this.salesList = push;
              } else {
                // console.log("suksessss not 200");
              }
            })
            .catch(function (error) {
                // console.log(error);
                //document.getElementById('testLoading').click();
            });
        }
      },
      resetPassword(item) {

        var name = item.first_name +" "+ item.last_name
        let message = 'Are you sure to Reset Password for ' + name +'?'
        this.$swal({title: message, html:'',text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Reset Password',
          confirmButtonColor: '#DC3545',
          showCloseButton: false,
          showLoaderOnConfirm: true,
        })
        .then((result) => {
            if(result.value) {
              axios.get(apiRouter().reset_password + item.id, getHeaderToken())
              .then(response => {
                  // console.log("response", response.data.code)
                  if(response.data.code == '200'){
                    //console.log('boled');
                    this.modalOK('no', '', 'Reset Password for ' + name + ' success')
                  } else {
                    this.modalOK('no', '', 'Reset Password for ' + name + ' failed')
                  }
              }) .catch(function (error) {
                  this.modalOK('no', '', 'Reset Password for ' + name + ' failed')
              });
            }
        })
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = "abcdefghij"
        // this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      viewStructure(item){
        // console.log('item,', item);
        if(this.showStructure){
          this.showStructure = false;
        }else{
          this.showStructure = true;
        }
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        // this.currentPage = 1
        // console.log('email',filteredItems[0].email)
      },
      onFilteredMember(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsMember = filteredItems.length
        this.currentPage = 1
      },
      reloadPage(){
        window.location.reload()
      },
      toggle: function () {
        if (this.isFolder) {
          this.isOpen = !this.isOpen
        }
      },
      makeFolder: function () {
        if (!this.isFolder) {
        	this.$emit('make-folder', this.item)
          this.isOpen = true
        }
      }
    }
  }
</script>
<style>
    #sales-tree {
        list-style-type: none;
    }
    #sales-tree .treeview > a > .fa.fa-folder {
        margin-right: 4px;
    }
    #sales-tree .treeview.menu-open > a > .fa.fa-folder {
        margin-right: 2px;
    }
    #sales-tree .treeview.menu-open > a > .fa.fa-folder:before {
        content: "\f07c";
    }
    #sales-tree li>.btn-group {
        visibility: hidden;
    }
    #sales-tree li:hover > .btn-group {
        visibility: visible;
    }
    #sales-tree li > a {
        display: inline-block;
        vertical-align: middle;
        border-bottom: 1px dotted transparent;
        margin-right: 16px;
        pointer-events: none;
        cursor: not-allowed;
    }
    #sales-tree li > a:hover {
        border-bottom: 1px dotted #d5d5d5;
    }

    #loading{
      background: rgba(0, 0, 0, 0.8);
      border-radius: 12%;
      padding: 2%;
      display: block;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 99;
    }

</style>
